export enum ChecklistTaskType {
  Checkbox = 'Checkbox',
  InputNumber = 'input number',
  Radio = 'radio',
  InputText = 'input text',
  Dropdown = 'dropdown',
  DatePicker = 'datepicker',
  CheckboxGroup = 'checkbox multiple',
  QrCodeCheckbox = 'QR code checkbox',
}
